import { getUserRole } from "Redux/Query";

const selectorFnCache = new WeakMap();

export const userContainsRole = state => {
  if (selectorFnCache.has(state)) {
    return selectorFnCache.get(state);
  }

  const userRole = getUserRole(state);

  const fn = roles => roles.includes(userRole);

  selectorFnCache.set(state, fn);

  return fn;
};
